/*
 * TangTalk：二级导航
 * 把主导航里「- 」「+ 」开头的项收进上一项的下拉菜单（写法和 The Reporter 一致，同一份 Ghost 导航设置两套主题通用）。
 * 必须在 main.js 调用 dropdown() 之前执行：dropdown() 会记下当时的 nav.innerHTML，窗口缩放时用它重置导航。
 * gulpfile 里已把本文件排在 assets/js/*.js 最前面。
 * 手机菜单里的展开/收起用事件委托，nav 被重置后照样有效。
 */
(function () {
    var menu = document.querySelector('.gh-navigation-menu');
    var nav = menu ? menu.querySelector('.nav') : null;
    if (!nav) return;

    var chevron = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var parent = null;

    Array.prototype.slice.call(nav.children).forEach(function (li) {
        var a = li.querySelector('a');
        if (!a) return;
        var text = a.textContent.trim();
        var isSub = /^[-+]\s/.test(text);

        if (!isSub) {
            parent = li;
            return;
        }
        if (!parent) {
            li.remove();
            return;
        }

        var sub = parent.querySelector('.tt-submenu');
        if (!sub) {
            sub = document.createElement('ul');
            sub.className = 'tt-submenu';
            var toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'tt-sub-toggle';
            toggle.setAttribute('aria-label', '展开「' + parent.textContent.trim() + '」子菜单');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.innerHTML = chevron;
            parent.classList.add('tt-has-sub');
            parent.appendChild(toggle);
            parent.appendChild(sub);
        }

        a.textContent = text.replace(/^[-+]\s+/, '');
        li.classList.remove('tt-sub');
        sub.appendChild(li);
    });

    menu.addEventListener('click', function (e) {
        var toggle = e.target.closest('.tt-sub-toggle');
        if (!toggle) return;
        e.preventDefault();
        var item = toggle.parentElement;
        var open = item.classList.toggle('is-sub-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
})();
